import React, { Component } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import IconPicker, { icons } from "../Shared/IconPicker/IconPicker";
import Pluralize from "pluralize";
import InnerLoader from "../Shared/Loader/InnerLoader";
import ErrorMessage from "../Shared/Error/ErrorMessage";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader"
import { removeSpecialCharacters } from "./utils";
import { withTranslation } from 'react-i18next';
import { createEntityConfigurations } from "../../API/Entity/Entity";


class CreateEntityDialog extends Component {

	createBtn = React.createRef();
	createAndNewBtn = React.createRef();
	EntityInput = React.createRef();
	constructor(props) {
		super(props);
		this.state = {
			formFields: {
				name: "",
				icon: "",
			},
			errors: {
				isNameValid: true,
				nameError: "",
			},
			creatingEntity: false,
			currentHoveredElement: {},
			showTooltip: false,
		};
	}

	render() {
		const { visible } = this.props;

		if (!visible) {
			return null;
		}

		return (
			<Dialog title={this.props.t("entity.create_dialog.title")} onClose={() => this.toggleDialog(false)}>
				<form onSubmit={this.createEntity}>
					<label htmlFor="entity-name" className="form-label d-inline-block" required>
						{this.props.t("entity.create_dialog.name_label")}
					</label>
					<ErrorMessage valid={this.state.errors.isNameValid} error={this.state.errors.nameError} />
					<input
						id="entity-name"
						name="EntityNameInput"
						ref={this.EntityInput}
						className="form-control name-text"
						autoFocus={true}
						value={this.state.formFields.name}
						onChange={this.handleNameChange}
						maxLength={64}
					/>
					<div className="form-label d-block">
						{this.props.t("entity.create_dialog.icon_label")}
					</div>
					<IconPicker onChange={this.handleIconChange} selected={this.state.formFields.icon} />
					<DialogActionsBar layout="end">
						<small className="mt-1">
							{this.state.creatingEntity && (
								<div className="d-inline-block">
									<InnerLoader borderColor="green" />
									<span className="me-4 text-success"></span>
								</div>
							)}
						</small>
						<button type="button" onClick={() => this.toggleDialog(false)} className="btn btn-secondary" data-testid="cancel-btn">
							{this.props.t("entity.create_dialog.buttons.cancel_label")}
						</button>
						{this.props.createandNew && (
							<button ref={this.createAndNewBtn} type={"submit"} onClick={this.createEntityAndReset} disabled={this.shouldCreateBeDisabled()} className="btn btn-primary" data-testid="create-and-new-btn">
								{this.props.t("entity.create_dialog.buttons.create_and_new_label")}
							</button>
						)}
						<button type={'button'} ref={this.createBtn} onClick={this.createEntity} disabled={this.shouldCreateBeDisabled()} className="btn btn-primary" data-testid="create-btn">
							{this.props.t("entity.create_dialog.buttons.create_label")}
						</button>
					</DialogActionsBar>
				</form>
				{
					this.state.creatingEntity &&
					<OverlayLoader />
				}
			</Dialog >
		);
	}

	componentDidMount() {
		const icon = this.getNextIcon();
		this.setState({ icon });
	}

	componentDidUpdate(props) {
		if (
			props.visible !== this.props.visible ||
			props.entities.length !== this.props.entities.length
		) {
			const name = "";
			const icon = this.getNextIcon();
			this.setState({
				formFields: { name, icon }
			});
		}
	}

	getNextIcon = () => {
		const { entities } = this.props;
		const newIcon = icons[entities.length % icons.length];
		return newIcon;
	};

	reset = () => {
		this.setState({
			formFields: {
				name: "",
				icon: "",
			},
			errors: {
				isNameValid: true,
				nameError: "",
			},
			creatingEntity: false,
		});
	};

	toggleDialog = (showUpgradeDailog) => {
		this.reset();
		this.props.toggle(showUpgradeDailog);
	};

	handleIconChange = (icon) => {
		const { formFields } = this.state;
		formFields.icon = icon;
		this.setState({
			formFields,
		});
	};

	handleNameChange = (e) => {
		const { formFields } = this.state;
		const { value } = e.target;
		formFields.name = value;
		const errors = this.validateForm(formFields);
		this.setState({
			formFields,
			errors,
		});
	};

	validateForm = (formFields) => {
		const errors = {
			isNameValid: true,
			nameError: "",
		};

		const { entities } = this.props;

		const name = removeSpecialCharacters(formFields.name.trim().toLowerCase());
		debugger
		const entityNameInUse = entities.findIndex((entity) => (
			removeSpecialCharacters(entity.name.trim().toLowerCase()) === removeSpecialCharacters(formFields.name.trim().toLowerCase())
		)) > -1;

		if (formFields.name.trim() === "") {
			errors.isNameValid = false
			errors.nameError = this.props.t("entity.create_dialog.errors.name_required")
		} else if (formFields.name.trim().match(/^\d/)) {
			errors.isNameValid = false
			errors.nameError = this.props.t("entity.create_dialog.errors.name_can_not_start_with_number")
		} else if (entityNameInUse) {
			errors.isNameValid = false;
			errors.nameError = this.props.t("entity.create_dialog.errors.name_exists");
		} else if (formFields.name.trim().length > 30) {
			errors.isNameValid = false;
			errors.nameError = this.props.t("entity.create_dialog.errors.name_length_exceeded");
		}

		return errors;
	};

	shouldCreateBeDisabled = () => {
		const { name } = this.state.formFields;
		const { errors } = this.state;
		return name.trim() === "" || !errors.isNameValid;
	};

	getOrder = () => {
		if (this.props.entities.length === 0) {
			return "10000000000";
		}
		const order = parseInt(this.props.entities[this.props.entities.length - 1].order) + 10000000000;
		return String(order);
	};

	isStringInEnglish = (str) => {
		const isEnglish = /^[A-Za-z\s]+$/.test(str);
		return isEnglish;
	};

	generateSystemName = () => {
		const { entities } = this.props;
		const { name } = this.state.formFields;
		let initialName = name.replace(/[^a-zA-Z]/g, "").toLowerCase();
		if (initialName === "") {
			initialName = "entity";
		}
		const isSysNameInEnglish = this.isStringInEnglish(initialName);
		if (!isSysNameInEnglish) {
			return "entity";
		} else {
			let systemName = initialName;
			let counter = 0;
			for (let i = 0; i < entities.length; i++) {
				if (entities[i].sysName === systemName) {
					counter++;
					systemName = initialName + String(counter);
					i = 0;
				}
			}
			return systemName;
		}
	};

	createEntity = async (e, isCreateandNew = false) => {
		e.preventDefault();
		const { createBtn, createAndNewBtn } = this;
		this.setState({
			creatingEntity: true,
		});

		createBtn.current.disabled = true;
		if (this.props.createandNew) createAndNewBtn.current.disabled = true;

		const { projectId, subscriptionId } = this.props;

		const { formFields } = this.state;
		formFields.name = formFields.name.trim()
		const order = this.getOrder();
		const systemName = this.generateSystemName();

		const entityProperties = {
			name: formFields.name,
			Icon: formFields.icon,
			order,
			sysName: systemName,
			IconColor: "#000",
			description: "",
			label: formFields.name,
			pluralLabel: formFields.name.match(".*\\d.*") ? formFields.name : Pluralize.plural(formFields.name),
			tooltip: formFields.name,
			allowAttachement: true,
			allowMultiple: true,
			languages: {},
			allowSize: 5,
			allowTypes: ".doc,.jpg,.pdf,.zip,.json",
		};

		try {
			console.time("Create entity: ");
			const entity = await createEntityConfigurations(projectId, {
				subscriptionId: subscriptionId,
				properties: entityProperties
			});
			if (entity.status && entity.status === "Failure") {
				this.toggleDialog(true)
			} else {
				entity.indexId = this.props.entities.length + 1;
				this.reset();
				this.props.onCreate(entity, isCreateandNew);
			}
		} catch (e) {
			console.error(e);
		}
	};

	createEntityAndReset = async (e) => {
		try {
			e.preventDefault();
			await this.createEntity(e, true);
			this.EntityInput.current.focus();
		} catch (error) {
			console.error(error);
		}
	};
}

export default withTranslation()(CreateEntityDialog);
